import React from 'react';
import CookieBanner from 'react-cookie-banner';

import './CookieBanner.module.css';

const styles = {
    banner: {
        fontFamily: 'HelveticaNeue,sans-serif',
        height: 'auto',
        background: 'rgba(52, 64, 81, 0.88) url(/cookie.png) 20px 50% no-repeat',
        backgroundSize: '30px 30px',
        backgroundColor: '',
        fontSize: '15px',
        fontWeight: 600,
        position: 'fixed',
        bottom: 0
    },
    button: {
        border: '1px solid white',
        borderRadius: 4,
        width: 90,
        height: 32,
        lineHeight: '32px',
        background: 'transparent',
        color: 'white',
        fontSize: '14px',
        fontWeight: 600,
        opacity: 1,
        right: 20,
        marginTop: -18
    },
    message: {
        display: 'block',
        padding: '9px 67px',
        lineHeight: 1.3,
        textAlign: 'left',
        marginRight: 100,
        color: 'white'
    },
    link: {
        textDecoration: 'none',
        fontWeight: 'bold',
        margin: 0
    }
};

const message = "Wir verwenden Cookies, um unsere Webseite für Sie möglichst benutzerfreundlich zu gestalten. Wenn Sie fortfahren, nehmen wir an, dass Sie mit der Verwendung von Cookies einverstanden sind. "


export default function MyCookieBanner() {

    return (
      <div>
        <CookieBanner
            styles={styles}
            message={message}
            link={{
                msg: 'Weitere Informationen',
                url: '/agb',
            }}
            buttonMessage='Schließen'
            dismissOnScroll={false}
        />
      </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/CookieBanner/CookieBanner.js